import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicHeader } from "@/components/PublicHeader";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import TopicDetailPage from "@/pages/TopicDetailPage";
import ArticleReadingPage from "@/pages/ArticleReadingPage";
import SearchResultsPage from "@/pages/SearchResultsPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ContactSupportPage from "@/pages/ContactSupportPage";
import CancellationPage from "@/pages/CancellationPage";

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F8F9FA]">
      <PublicHeader />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/topic/:slug" element={<TopicDetailPage />} />
              <Route path="/article/:slug" element={<ArticleReadingPage />} />
              <Route path="/search" element={<SearchResultsPage />} />
              <Route path="/support" element={<ContactSupportPage />} />
              <Route path="/cancel" element={<CancellationPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
